

















// @ts-ignore
import noUiSlider from 'nouislider'
import 'nouislider/distribute/nouislider.css'
import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'

export type NoUISliderOptions = Partial<noUiSlider.Options>

@Component
export default class NoUISlider extends Vue {
  @Prop({ default: null }) readonly sliderStartValue!: number | null
  @Prop({ default: null }) readonly sliderEndValue!: number | null
  @Prop({ default: null }) readonly sliderStep!: number | null
  @Prop({ default: null }) readonly sliderLowLimit!: number | null
  @Prop({ default: null }) readonly sliderHighLimit!: number | null
  @Prop({ default: null }) readonly sliderOptions!: NoUISliderOptions | null
  @Prop({ default: true }) readonly showSelectionInfo!: boolean

  // This borrows a dataflow classification from React:
  // https://reactjs.org/docs/uncontrolled-components.html
  @Prop({ default: false }) readonly isControlledComponent!: boolean

  @Prop({ default: '' }) readonly name!: string
  @Ref('slider-element') readonly sliderElement!: HTMLElement | null

  startValue = this.setValue(this.sliderStartValue) ?? 0
  endValue = this.setValue(this.sliderEndValue) ?? 10
  minRangeVal = this.startValue
  maxRangeVal = this.endValue
  slider?: noUiSlider.noUiSlider

  @Watch('minRangeVal')
  minRangeValUpdated () {
    this.updateSlider()
  }

  @Watch('maxRangeVal')
  maxRangeValUpdated () {
    this.updateSlider()
  }

  @Watch('sliderStartValue')
  @Watch('sliderEndValue')
  sliderValueUpdated () {
    if (this.slider && this.isControlledComponent) {
      this.slider.set([this.sliderStartValue, this.sliderEndValue])
    }
  }

  mounted () {
    if (!this.sliderElement) {
      console.error('No slider found')
      return
    }

    const settings: noUiSlider.Options = {
      ...this.sliderOptions,
      start: [this.startValue, this.endValue],
      step: this.sliderStep || undefined,
      connect: true,
      behaviour: 'snap',
      animate: false,
      direction: 'ltr',
      range: { min: this.minRangeVal, max: this.maxRangeVal }
    }

    if (this.sliderLowLimit) {
      settings.range.min = this.sliderLowLimit
    }

    if (this.sliderHighLimit) {
      settings.range.max = this.sliderHighLimit
    }

    const initializedSlider = noUiSlider.create(this.sliderElement, settings)
    this.slider = initializedSlider
    initializedSlider.on('update', this.onSliderUpdate)
    this.updateSlider()
  }

  setValue (val: number | null) {
    let sliderValue
    if (this.name === 'Household Income') {
      if (val === 26) sliderValue = 250000
      else if (val === 25) sliderValue = 250000
      else if (val === 24) sliderValue = 200000
      else if (val === 23) sliderValue = 175000
      else if (val === 22) sliderValue = 150000
      else if (val === 21) sliderValue = 125000
      else if (val === 20) return 100000
      else if (val === 0) return 0
      else if (val === 1) sliderValue = 5000
      else sliderValue = ((val ?? 0) - 1) * 5000

      return sliderValue
    }

    return val
  }

  convertHHIVals (val: number | string): string {
    if (val === 0) {
      return '<$5,000'
    } else if (val === 255000) {
      return '$250,000+'
    } else {
      const stringVal = String(parseInt(val as string))
      return '$' + stringVal.slice(0, -3) + ',' + stringVal.slice(-3)
    }
  }

  updateSlider () {
    const strMin = String(this.minRangeVal)
    const strMax = String(this.maxRangeVal)
    this.$emit('change', [parseInt(strMin), parseInt(strMax)])
  }

  onSliderUpdate (values: any[], handle: number) {
    if (this.minRangeVal || this.minRangeVal === 0) { // how'd i forget 0 is false.......
      if (handle === 0) {
        this.minRangeVal = parseInt(values[handle])
      } else {
        this.maxRangeVal = parseInt(values[handle])
      }
    } else {
      this.maxRangeVal = parseInt(values[handle])
    }
  }

  uuid4 () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0
      var v = c === 'x' ? r : r & 0x3 | 0x8
      return v.toString(16)
    })
  }
}
